<template>
  <div id="app">
      <div class="main-container">
        <Sidebar></Sidebar>
        <div class="content">
          <Header></Header>
          <!-- <Breadcrumb /> -->
          <div class="page-content">
            <router-view />
          </div>
        </div>
      </div>
  </div>
  <!-- <a-config-provider :getPopupContainer="getPopupContainer" :locale="zh_CN">
    <ThemeProvider is-root v-bind="themeConfig" :apply-style="false">
      <stepin-view
        system-name="Stepin"
        logo-src="@/assets/vite.svg"
        :class="`${contentClass}`"
        :user="user"
        :navMode="navigation"
        :useTabs="useTabs"
        :themeList="themeList"
        v-model:show-setting="showSetting"
        v-model:theme="theme"
        @themeSelect="configTheme"
        style="* { transition: none !important; }"
      >
        <template #headerActions>
          <HeaderActions @showSetting="showSetting = true" />
        </template>
    
      </stepin-view>
    </ThemeProvider>
  </a-config-provider> -->
  <!-- <login-modal :unless="['/login']" /> -->
</template>

<script lang="ts" setup>
  import { reactive, ref } from 'vue';
  import { useRouter } from 'vue-router';
  import {getUserInfo} from '@/api/common';
  import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
  import { useAccountStore, useMenuStore, useSettingStore, storeToRefs } from '@/store';
  import avatar from '@/assets/avatar.png';
  import { PageFooter, HeaderActions } from '@/components/layout';
//   import Setting from './components/setting';
  import { LoginModal } from '@/pages/login';
  import { configTheme, themeList } from '@/theme';
  import { ThemeProvider } from 'stepin';
  import { computed } from 'vue';
  import Header from './Header.vue';
  import Sidebar from './Sidebar.vue';
  // import Breadcrumb from './Breadcrumb.vue';

  // const { logout, profile } = useAccountStore();

  // 获取个人信息
  // profile().then((response) => {
  //   const { account } = response;
  //   user.name = account.username;
  //   // user.avatar = account.avatar;
  // });

  const showSetting = ref(false);
  const router = useRouter();

  // useMenuStore().getMenuList();

  const { navigation, useTabs, theme, contentClass } = storeToRefs(useSettingStore());
  const themeConfig = computed(() => themeList.find((item) => item.key === theme.value)?.config ?? {});

  const user = reactive({
    name: 'admin',
    avatar: avatar,
    // menuList: [
    //   { title: '个人中心', key: 'personal', icon: 'UserOutlined', onClick: () => router.push('/profile') },
    //   { title: '设置', key: 'setting', icon: 'SettingOutlined', onClick: () => (showSetting.value = true) },
    //   { type: 'divider' },
    //   {
    //     title: '退出登录',
    //     key: 'logout',
    //     icon: 'LogoutOutlined',
    //     onClick: () => logout().then(() => router.push('/login')),
    //   },
    // ],
  });

  function getPopupContainer() {
    return document.querySelector('.stepin-layout');
  }
  const getUser = ()=>{
    getUserInfo().then(res=>{
      let userInfo = localStorage.getItem("userInfo");
      if(!userInfo || userInfo==''){
        localStorage.setItem("userInfo",JSON.stringify(res.data));
      }
      
    })
  }
  // getUser();
</script>

<style lang="less">
  @import '@/styles/variables.less';
  #app {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .main-container {
    display: flex;
    flex: 1;
    background-color: #fff;
    background-color: var(--dark-color);
  }

  .content {
    flex: 1;
    overflow-y: auto;
    transition: margin-left 0.3s ease;
    background-color: #EBECEE;
    border-top-left-radius: 29px;
    border-bottom-left-radius: 29px;
    &.sidebar-collapsed {
      margin-left: -180px;
    }
  }

  .page-content {
    // background-color: white;
    // border-radius: @border-radius;
    // box-shadow: @shadow;
    // padding: 20px;
    // min-height: 400px;

    height: calc(100% - 120px);

  }
  .stepin-view {
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
      border-radius: 4px;
      background-color: theme('colors.primary.500');
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: theme('colors.primary.400');

      &:hover {
        background-color: theme('colors.primary.500');
      }
    }

    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
      border-radius: 4px;
      background: theme('backgroundColor.layout');
    }
  }

  html {
    height: 100vh;
    overflow-y: hidden;
  }

  body {
    margin: 0;
    height: 100vh;
    overflow-y: hidden;
  }
  .stepin-img-checkbox {
    @apply transition-transform;
    &:hover {
      @apply scale-105 ~"-translate-y-[2px]";
    }
    img {
      @apply shadow-low rounded-md transition-transform;
    }
  }
  .ant-card-head, .ant-card-body{
    background-color:#FAFAFA!important;
    box-shadow: 
    inset 0 0 5px 2px #EFF8FB,
    inset 0 0 15px 5px #EFF8FB;
  }
</style>
